var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upsell-popup-bg-wrapper",on:{"click":_vm.closePopup}},[_c('div',{staticClass:"upsell-popup-bg-container"},[_c('div',{staticClass:"upsell-popup-bg-content"},[_c('Template',{attrs:{"template":_vm.template,"editorMode":_vm.EDITOR_MODE_VIEW,"closePopup":_vm.closePopup}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }